import { render, staticRenderFns } from "./MaterialsManageDetail.vue?vue&type=template&id=65289ace&scoped=true"
import script from "./MaterialsManageDetail.vue?vue&type=script&lang=js"
export * from "./MaterialsManageDetail.vue?vue&type=script&lang=js"
import style0 from "./MaterialsManageDetail.vue?vue&type=style&index=0&id=65289ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65289ace",
  null
  
)

export default component.exports